import { useAuth } from '../../auth/useAuth';

export default function LangToggle() {
    const { lang, setLang } = useAuth();

    const toggle = (newLang) => {
        if (lang !== newLang) {
            setLang(newLang);
        }
    };

    return (
        <div
            style={{
                display: 'flex',
                border: '1px solid var(--border)',
                borderRadius: '4px',
                overflow: 'hidden',
            }}
        >
            <button
                onClick={() => toggle('vi')}
                style={{
                    padding: '0.3rem 0.75rem',
                    fontSize: '0.75rem',
                    fontWeight: 600,
                    border: 'none',
                    cursor: 'pointer',
                    background: lang === 'vi' ? 'var(--gold)' : 'transparent',
                    color: lang === 'vi' ? 'var(--bg-primary)' : 'var(--text-secondary)',
                }}
                title="Tiếng Việt"
            >
                VI
            </button>
            <button
                onClick={() => toggle('en')}
                style={{
                    padding: '0.3rem 0.75rem',
                    fontSize: '0.75rem',
                    fontWeight: 600,
                    border: 'none',
                    cursor: 'pointer',
                    borderLeft: '1px solid var(--border)',
                    background: lang === 'en' ? 'var(--gold)' : 'transparent',
                    color: lang === 'en' ? 'var(--bg-primary)' : 'var(--text-secondary)',
                }}
                title="English"
            >
                EN
            </button>
        </div>
    );
}